import { render, staticRenderFns } from "./EditInstitutionDetails.vue?vue&type=template&id=06068931&scoped=true"
import script from "./EditInstitutionDetails.vue?vue&type=script&lang=js"
export * from "./EditInstitutionDetails.vue?vue&type=script&lang=js"
import style0 from "./EditInstitutionDetails.vue?vue&type=style&index=0&id=06068931&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06068931",
  null
  
)

export default component.exports